module.exports = __webpack_public_path__ + "3ce462cb9163fe81a7d6434a42dc644c.pdf";